import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { name: 'Telugu', available: true },
    { name: 'Hindi', available: false },
    { name: 'Tamil', available: false },
    { name: 'Kannada', available: false },
    { name: 'Malayalam', available: false },
    { name: 'English (Indian)', available: false }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative z-50 flex items-center gap-2" ref={dropdownRef}>
      <span className="text-[0.875rem] text-[#B0B4BB] font-bold whitespace-nowrap">
        Select Language:
      </span>
      <div className="relative flex-1">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full px-2 py-1 bg-[#181A1B] text-[#EAECEF] border border-[#3A3D3E]
                     rounded-lg flex items-center justify-between
                     focus:outline-none focus:ring-1 focus:ring-[#178A94]
                     hover:bg-[#2C2F30] transition-colors min-w-[120px]"
        >
          <span className="text-sm">Telugu</span>
          <ChevronDown size={16} className="text-[#B0B4BB]" />
        </button>
        
        {isOpen && (
          <div className="absolute top-full left-0 w-full mt-1
                         bg-[#2C2F30] border border-[#3A3D3E] rounded-lg shadow-xl
                         overflow-hidden z-50">
            <div className="py-1">
              {languages.map((lang) => (
                <button
                  key={lang.name}
                  disabled={!lang.available}
                  className={`w-full px-3 py-2 text-left
                            text-sm
                            flex items-center justify-between
                            ${lang.available 
                              ? 'text-[#EAECEF] hover:bg-[#3A3D3E]' 
                              : 'text-[#7C8085] cursor-not-allowed'
                            } transition-colors`}
                  onClick={() => lang.available && setIsOpen(false)}
                >
                  {lang.name}
                  {!lang.available && 
                    <span className="text-[#7C8085] text-xs ml-2">Coming Soon</span>
                  }
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;